import AdminConfig from './admin';

import ClientView from './CalendarModule';


export default {
  name : 'calendar',

  type : 'module',
  
  label: 'calendrier',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-calendar',
  }
}